export type AiRecsFlag = {
  enabled: boolean;
  raw: string | undefined;
  source: string;
};

export const getAIRecsFlag = (): AiRecsFlag => {
  const raw = process.env.REACT_APP_ENABLE_AI_RECOMMENDATIONS;
  const normalized = raw ? raw.toLowerCase().trim() : '';
  const enabled = normalized === 'true' || normalized === '1' || normalized === 'yes';
  return {
    enabled,
    raw,
    source: 'REACT_APP_ENABLE_AI_RECOMMENDATIONS',
  };
};
